export default __webpack_public_path__ + "7501f527804c13c28a31c3a17adc4640.svg";